module.exports = __webpack_public_path__ + "img/Rectangle 754 3.9ea1a595.png";